<script>
import moment from 'moment';
import 'moment-duration-format';

export default {
  name: 'CountdownTimer',
  props: {
    remainingTime: {
      required: true,
      validator: (val) => val === null || typeof val === 'number',
    },
    status: {
      default: 'disabled',
      type: String,
    },
  },
  computed: {
    remainingDuration () { // TODO change for formatMillisecondsToHMS
      const duration = Math.max(0, this.remainingTime);
      const [hours, minutes, seconds] = moment.duration(duration).format('hh:mm:ss', { trim: false }).split(':');
      return { hours, minutes, seconds };
    },
    isDisabled () {
      return this.status === 'disabled';
    },
    isPaused () {
      return this.status === 'paused';
    },
    isInfinite () {
      return this.status === 'infinite';
    },
    secsToDisplay () {
      return this.isDisabled ? '--' : this.remainingDuration.seconds;
    },
    minToDisplay () {
      return this.isDisabled ? '--' : this.remainingDuration.minutes;
    },
    hoursToDisplay () {
      return this.isDisabled ? '--' : this.remainingDuration.hours;
    },
  },
};
</script>

<template lang="pug">
h3.counter.b.mv2.f3(:class="[isPaused ? 'animated-2 infinite flash' : '']")
  | #[span.hours.dib.v-mid {{ hoursToDisplay }}]#[span.f4.dib.v-mid.mh1 :]#[span.minutes.dib.v-mid {{ minToDisplay }}]#[span.f4.dib.v-mid.mh1 :]#[span.seconds.dib.v-mid {{ secsToDisplay }}]
</template>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@import "styles/variables.css";
.countdown-timer {

}
</style>
